import { useEffect, useState } from 'react'
import { uploadQueueManager, QueueStatus } from '../lib/upload-queue'

export function useUploadQueue() {
  const [status, setStatus] = useState<QueueStatus>({
    isProcessing: false,
    totalCount: 0,
    pendingCount: 0,
    uploadingCount: 0,
    failedCount: 0,
    duplicateCount: 0,
    items: [],

  })

  useEffect(() => {
    const unsubscribe = uploadQueueManager.subscribe((newStatus) => {
      setStatus(newStatus)
    })
    return unsubscribe
  }, [])

  return {
    ...status,
    enqueuePhotos: (
      homeId: number,
      files: File[],
      workOrderId?: number,
      tags?: string[],
      description?: string,
      homeownerId?: number,
      homeownerName?: string
    ) => uploadQueueManager.enqueuePhotos(homeId, files, workOrderId, tags, description, homeownerId, homeownerName),

    enqueueBasePhotos: (
      regionId: number,
      files: File[],
      componentName?: string,
      description?: string
    ) => uploadQueueManager.enqueueBasePhotos(regionId, files, componentName, description),
    processQueue: () => uploadQueueManager.processQueue(),
    clearQueue: () => uploadQueueManager.clearQueue(),
    retryFailed: () => uploadQueueManager.retryFailedItems(),
    removeItem: (id: number) => uploadQueueManager.removeItem(id),
  }
}

